<!-- Tạo hợp đồng ngay -->
<h6
  class="row"
  style="padding-left: 1em; padding-right: 1em"
  *ngIf="!isShowStep"
>
  <div class="drd-container col-12" *ngIf="commonService.getIsLockedEnterprise()">
    <span style="display: block;">
      {{ "enterprise_contract.panel_document.lb_create_document_is_locked_1" | translate }}
    </span>
    <span style="display: block; margin-top: 4px;">
      {{ "enterprise_contract.panel_document.lb_create_document_is_locked_2" | translate }}
    </span>
  </div>
  <div class="drd-container col-12" *ngIf="!commonService.getIsLockedEnterprise()">
    <br />
    <h3 style="color: #005e5b">
      {{ "enterprise_contract.panel_document.lb_create_document" | translate }}
    </h3>
    <br />
    <button
      #btnUpload appTrackEvent="w.btn.lap_hd_file.chon_tep_tu_may"
      id="btnUpload"
      mat-stroked-button
      class="mr-2"
      color="primary"
      type="button"
      (click)="inputUpload.click()"
      [ngClass]="{ active_document: false }"
    >
      <mat-icon class="mr-0">cloud_upload</mat-icon>
      {{ "button.choose_a_file" | translate }}
    </button>
    <input
      type="file"
      #inputUpload
      id="file"
      accept="application/pdf"
      class="form-control-file vt-input-form d-none mat-stroked-button-create-document"
      name="file"
      (change)="onSelectedUpload($event)"
      multiple
    />
    {{ "enterprise_contract.panel_document.lb_or" | translate }}
    <button
      #btnForm appTrackEvent="w.btn.lạp_hd_mau.chon_tu_mau_khac"
      mat-stroked-button
      class="ml-2"
      color="primary"
      type="button"
      [ngStyle]="{ color: null }"
      [ngClass]="{ active_document: false }"
      (click)="onSelectedFormClick()"
      id="btnSelectTemplate"
    >
      <mat-icon class="mr-0">book</mat-icon>
      {{ "button.document_form" | translate }}
    </button>
    <h5 style="margin-top: 2em">
      ({{ mesage }})
      <!-- {{ "validation.validate_file_types" | translate }} -->
    </h5>
    <br /><br />
  </div>
  <div *ngIf="arrFile.length > 0 && isShowFileError" style="display: grid;
    justify-content: start">
      <span class="title-header-upload" style="margin-top: 32px">{{ "enterprise_contract.list_document_upload" | translate }}</span>
      <div style="display: grid; justify-content: start" *ngFor="let item of arrFile ? arrFile : []">
        <div class="fix-width mt-3" style="display: flex;flex-direction: row">
            <div>
                <button class="icon-file">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="31" viewBox="0 0 32 31" fill="none">
                       <path d="M28.7099 17.1583H3.28935L1.38281 14.6163L3.92487 12.0742H28.0744L30.6164 14.6163L28.7099 17.1583Z" fill="#870000"/>
                       <path d="M26.8043 29.8684H5.19681C4.49457 29.8684 3.92578 29.2996 3.92578 28.5974V1.90579C3.92578 1.20355 4.49457 0.634766 5.19681 0.634766H20.4491L28.0753 8.26093V28.5974C28.0753 29.2996 27.5065 29.8684 26.8043 29.8684Z" fill="white"/>
                       <path d="M20.4492 0.634766V6.9899C20.4492 7.69214 21.018 8.26093 21.7202 8.26093H28.0754L20.4492 0.634766Z" fill="#CDCDCD"/>
                       <path d="M29.3454 26.0545H2.65384C1.9516 26.0545 1.38281 25.4857 1.38281 24.7834V14.6152H30.6164V24.7834C30.6164 25.4857 30.0476 26.0545 29.3454 26.0545Z" fill="#BD0100"/>
                       <path d="M13.5046 19.4742C13.5046 20.0322 13.34 20.4631 13.0114 20.7662C12.6822 21.0706 12.2158 21.2219 11.6101 21.2219H11.2314V22.8774H9.88281V17.8867H11.6101C12.2406 17.8867 12.714 18.0246 13.0299 18.2992C13.3464 18.575 13.5046 18.9671 13.5046 19.4742ZM11.2314 20.1231H11.4773C11.68 20.1231 11.8408 20.0659 11.9603 19.9515C12.0798 19.8377 12.1395 19.6808 12.1395 19.4812C12.1395 19.1444 11.9533 18.976 11.5796 18.976H11.2314V20.1231Z" fill="white"/>
                       <path d="M18.5332 20.2762C18.5332 21.1094 18.3038 21.7506 17.8449 22.2012C17.3867 22.6524 16.7423 22.8774 15.9117 22.8774H14.2969V17.8867H16.0242C16.8249 17.8867 17.4433 18.0914 17.8793 18.5013C18.3152 18.9112 18.5332 19.5022 18.5332 20.2762ZM17.1338 20.3239C17.1338 19.8663 17.0436 19.5276 16.8624 19.3065C16.682 19.0853 16.4068 18.9754 16.0382 18.9754H15.6454V21.7703H15.946C16.3559 21.7703 16.6559 21.6509 16.8472 21.4132C17.0385 21.1755 17.1338 20.8133 17.1338 20.3239Z" fill="white"/>
                       <path d="M20.7573 22.8774H19.4297V17.8867H22.3791V18.9684H20.7579V19.921H22.2533V21.0026H20.7579V22.8774H20.7573Z" fill="white"/>
                     </svg>
                 </button>
            </div>

        <div style="display: flex;flex-direction: column">
            <span style="margin-left: 16px; margin-top: 6px; text-align: left;">
                <span class="name-file-upload" style="white-space: break-spaces;"> {{item?.name}}</span>
            </span>
            <span class="mb-file-upload" style="text-align: left; margin-left: 20px">{{item?.size | byte}}</span>
          </div>

        </div>
      </div>
    </div>
</h6>


<!--step-->
<mat-card *ngIf="isShowStep">
  <mat-card-content class="mat-card-content-contract-sm">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mb-0">
        <div class="steps-title">
          <!--    title của step-->
          <nz-steps [nzCurrent]="current" class="mb-3">
            <nz-step [nzTitle]="titleStep1">
              <ng-template #titleStep1>{{
                "enterprise_contract.add_document.steps.step_1" | translate
              }}</ng-template>
            </nz-step>
            <nz-step [nzTitle]="titleStep2" *ngIf="valueSelect !== 1">
              <ng-template #titleStep2>{{
                "enterprise_contract.add_document.steps.step_2" | translate
              }}</ng-template>
            </nz-step>
            <nz-step [nzTitle]="titleStep3">
              <ng-template #titleStep3>{{
                "enterprise_contract.add_document.steps.step_3" | translate
              }}</ng-template>
            </nz-step>
          </nz-steps>
          <!--end title của step-->
        </div>

        <!--    nội dung, các phần này thay đổi-->
        <!--    tab thông tin chung-->
        <div *ngIf="current == 0" class="max-width-content-step0">
          <div class="pb-3 pt-2">
            <app-fill-general-contract-info [maxSize]="maxSize"></app-fill-general-contract-info>
          </div>
        </div>
        <!--    end tab chọn phương thức ký-->

        <!-- điền nội dung hợp đồng -->
        <div class="steps-content max-width-content-step1" *ngIf="current == 1">
          <div class="document overflow-hidden">
            <app-document-form #documentForm></app-document-form>
          </div>
        </div>

        <!-- preview hợp đồng -->
        <div
          class="parent-document steps-content max-width-content-step23"
          *ngIf="current == 2"
        >
          <div class="document scrollbar_scontract_xs">
            <app-preview-contract [checkMan] =  "true" [selectForm]="choose_form" [maxSize]="maxSize"></app-preview-contract>
          </div>
        </div>
        <!--    end nội dung, các phần này thay đổi-->
      </mat-expansion-panel>

      <!-- Button show desktop, tablet -->
      <!-- <div class="col-12 pr-0" style="border-left: 1px solid #e3e6f0;">
        <div class="bg-white text-center mat-elevation-z0 py-2 w-100"> -->

      <div
        class="bg-white text-center mat-elevation-z0 py-2 w-100"
        id="navigation"
        #navigation
        style="border-top: 1px solid #0000001f;position: sticky;bottom: 0;display: flex;align-items: center;justify-content: center;padding-right: 11rem;z-index: 1;"
      >
      <!--        nút huỷ bỏ-->
        <button
          id="btn-cancel"
          mat-stroked-button
          color="primary" appTrackEvent="w.btn.lap_hd.huy_bo"
          class="mr-3"
          type="button"
          (click)="onClickBtnCancel()"
        >
          <mat-icon class="mr-0">cancel</mat-icon>
          {{ "button.cancel" | translate }}
        </button>
        <!--      nút quay lại-->
        <button
          (click)="prev()"
          *ngIf="current > 0" appTrackEvent="w.btn.lap_hd.quay_lai"
          mat-stroked-button
          class="mr-3"
          color="primary"
        >
          <mat-icon class="mr-0">arrow_back</mat-icon>
          {{ "button.back" | translate }}
        </button>
        <!--      nút tiếp tục -->
        <button
          (click)="next()"
          *ngIf="current < 2" appTrackEvent="w.btn.lap_hd.tiep_theo"
          mat-raised-button
          class="mr-3"
          color="primary"
          [disabled]="isDisableNextButton"
        >
          {{ "button.next" | translate }}
          <mat-icon class="mr-0">arrow_forward</mat-icon>
        </button>
        <!--        nút lưu hđ-->
        <button
          mat-stroked-button
          *ngIf="current === 2" appTrackEvent="w.btn.lap_hd.luu_nhap"
          (click)="onClickBtnSave(true); isNegotiate = false"
          class="mr-3"
          type="submit"
          color="primary"
        >
          <mat-icon class="mr-0">save</mat-icon>
          <ng-container>
            {{ "button.save_draft" | translate }}
          </ng-container>
          <!-- <ng-container *ngIf="contractId  && !flagCopy">
            {{ "button.save_draft" | translate }}
          </ng-container> -->
        </button>

        <button
          mat-stroked-button
          *ngIf="current === 2 && (!isUpdate || isUpdate && !createContractService.document.getValue().negotiate) && !createContractService.document.getValue().formType"
          (click)="openPopupConfirm();"
          class="mr-3"
          type="submit"
          color="primary"
        >
          <svg width="24" height="24" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.05 10.5C5.90833 10.5 5.78967 10.452 5.694 10.356C5.59833 10.26 5.55033 10.1413 5.55 10C5.55 9.94167 5.5625 9.88117 5.5875 9.8185C5.6125 9.75583 5.65 9.69967 5.7 9.65L8.0125 7.3375L7.65 6.975L5.35 9.2875C5.3 9.3375 5.24583 9.375 5.1875 9.4C5.12917 9.425 5.06667 9.4375 5 9.4375C4.85833 9.4375 4.73967 9.38967 4.644 9.294C4.54833 9.19833 4.50033 9.0795 4.5 8.9375C4.5 8.85417 4.5125 8.78534 4.5375 8.731C4.5625 8.67667 4.59583 8.62883 4.6375 8.5875L6.95 6.275L6.6 5.925L4.2875 8.225C4.2375 8.275 4.18333 8.3125 4.125 8.3375C4.06667 8.3625 4 8.375 3.925 8.375C3.79167 8.375 3.675 8.325 3.575 8.225C3.475 8.125 3.425 8.00834 3.425 7.875C3.425 7.80834 3.4375 7.74584 3.4625 7.6875C3.4875 7.62917 3.525 7.575 3.575 7.525L5.8875 5.2125L5.525 4.8625L3.225 7.175C3.18333 7.21667 3.13333 7.25 3.075 7.275C3.01667 7.3 2.94583 7.3125 2.8625 7.3125C2.72083 7.3125 2.602 7.2645 2.506 7.1685C2.41 7.0725 2.36217 6.95384 2.3625 6.8125C2.3625 6.74584 2.375 6.68334 2.4 6.625C2.425 6.56667 2.4625 6.5125 2.5125 6.4625L5.3 3.675L7.175 5.5625C7.26667 5.65417 7.375 5.72717 7.5 5.7815C7.625 5.83583 7.75 5.86284 7.875 5.8625C8.14167 5.8625 8.375 5.76884 8.575 5.5815C8.775 5.39417 8.875 5.1545 8.875 4.8625C8.875 4.74584 8.85417 4.625 8.8125 4.5C8.77083 4.375 8.69583 4.25834 8.5875 4.15L6.35 1.9125C6.49167 1.77917 6.65 1.67717 6.825 1.6065C7 1.53584 7.175 1.50034 7.35 1.5C7.56667 1.5 7.76667 1.5355 7.95 1.6065C8.13333 1.6775 8.3 1.78784 8.45 1.9375L10.5625 4.0625C10.7125 4.2125 10.823 4.37917 10.894 4.5625C10.965 4.74584 11.0003 4.95834 11 5.2C11 5.36667 10.9625 5.5355 10.8875 5.7065C10.8125 5.8775 10.7042 6.03367 10.5625 6.175L6.4 10.35C6.33333 10.4167 6.275 10.4583 6.225 10.475C6.175 10.4917 6.11667 10.5 6.05 10.5ZM1.7625 6.5L1.4375 6.175C1.29583 6.04167 1.1875 5.88334 1.1125 5.7C1.0375 5.51667 1 5.325 1 5.125C1 4.90834 1.04167 4.70834 1.125 4.525C1.20833 4.34167 1.3125 4.1875 1.4375 4.0625L3.55 1.9375C3.68333 1.80417 3.84167 1.69784 4.025 1.6185C4.20833 1.53917 4.3875 1.49967 4.5625 1.5C4.7875 1.5 4.9875 1.53134 5.1625 1.594C5.3375 1.65667 5.50833 1.77117 5.675 1.9375L8.2375 4.5C8.2875 4.55 8.325 4.60417 8.35 4.6625C8.375 4.72084 8.3875 4.78334 8.3875 4.85C8.3875 4.98334 8.3375 5.1 8.2375 5.2C8.1375 5.3 8.02083 5.35 7.8875 5.35C7.8125 5.35 7.75 5.33967 7.7 5.319C7.65 5.29834 7.59583 5.25867 7.5375 5.2L5.2875 2.975L1.7625 6.5Z" fill="#EE0033"/>
          </svg>
          
          <ng-container>
            {{ "negotiate_contract.negotiate" | translate }}
          </ng-container>
        </button>

        <button mat-raised-button color="primary" *ngIf="current === 2" class="btn mr-3" (click)="onClickBtnSave(false); isNegotiate = false" appTrackEvent="w.btn.lap_hd.thuc_hien_luong_ky">
          <mat-icon class="mr-0">send</mat-icon>
          {{ "enterprise_contract.buttons.start_flow" | translate }}
        </button>
        <!--      nút tiếp tục -->
        <!-- <button
          (click)="openSignatureDialog()"
          *ngIf="current === 2 && valueSelect === 0"
          mat-stroked-button
          type="button"
          color="primary"
        >
          {{ "button.signature" | translate }}
        </button> -->
      </div>
    </mat-accordion>
  </mat-card-content>
</mat-card>
